'use client';

import { GetResponseType } from '@/api/types/api';
import { ApiResponseDefinition } from '@/api/types/api-definition';
import { EPlatform } from '@/utils/enums/platform-enum';
import dynamic from 'next/dynamic';
import { FC, Suspense } from 'react';

const FooterV2 = dynamic(() => import('./index'), { ssr: true });

interface ClientFooterWrapperProps {
  isBot: boolean;
  deviceType: EPlatform;
  navList: GetResponseType<ApiResponseDefinition['GET:/api/nav/lists']>;
}

const ClientFooterWrapper: FC<ClientFooterWrapperProps> = ({ deviceType, navList }) => {
  return (
    <Suspense fallback={null}>
      <FooterV2 deviceType={deviceType} navList={navList} />
    </Suspense>
  );
};

export default ClientFooterWrapper;
